// import React from 'react';
import gql from 'graphql-tag';

export default payload => {
  const userLogin = `userLogin(input: {userName: "${
    payload.userName
  }", password: "${payload.password}"} )`;
  return gql`
  query {
    ${userLogin} {
      id
      userId
      accountId
      lastLoginDate
      lastPasswordChangeDate
      firstTimeLogin
      daysForPasswordChange
    }
  }
`;
};
